import {
  GET_LIST_OF_PUBLICATIONS,
  GET_LIST_OF_PUBLICATIONS_SUCCESS,
  GET_LIST_OF_PUBLICATIONS_TAGS_SUCCESS,
  GET_PUBLICATION_SUCCESS,
} from '../actions';

const initialState = {
  news: {},
  isNewsLoading: false,
  hashtags: {},
  publication: {},
};

export const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_OF_PUBLICATIONS:
      return {
        ...state,
        isNewsLoading: true,
      };
    case GET_LIST_OF_PUBLICATIONS_SUCCESS:
      return {
        ...state,
        news: action.payload,
        isNewsLoading: false,
      };
    case GET_LIST_OF_PUBLICATIONS_TAGS_SUCCESS:
      return {
        ...state,
        hashtags: action.payload,
      };
    case GET_PUBLICATION_SUCCESS:
      return {
        ...state,
        publication: action.payload,
      };
    default:
      return state;
  }
};
